import crash from './crash/store';
import cron from './cron/store';
import client from './client/store';

export default {
  namespaced: true,
  modules: { crash, cron, client },
};
